import React, {Component} from "react";
import {Alert, Modal, Button} from "reactstrap";
import PropTypes from "prop-types";
import {usersDelete} from "../../store/users/actions";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";

class DeleteModal extends Component {
  constructor(props) {
    super(props)
    this.state = {loading: false, error: ""}
  }

  onClose = () => {
    this.props.togModal(null)
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({loading: this.props.loading, response: this.props.response, error: this.props.error});
      if (this.props.response.status === 0) {
        this.props.usersRefresh({history: this.props.history})
        this.onClose()
      }
    }
  }

  render() {
    return (<React.Fragment>
      <Modal isOpen={true} toggle={this.onClose}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            Delete User
          </h5>
          <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div className="modal-body">
          Do you really want to delete user {this.props.userData.username}?
        </div>
        <div className="modal-footer">
          {this.state.loading && (<div className="spinner-border text-primary m-1 me-auto" role="status">
            <span className="sr-only">Loading...</span>
          </div>)}
          {this.state.error.length > 0 && (<Alert color="danger" role="alert" className="me-auto">
            {this.state.error}
          </Alert>)}
          <Button color="secondary" onClick={this.onClose} data-dismiss="modal">
            Close
          </Button>
          <Button color="danger" onClick={() => this.props.onUsersDelete({history: this.props.history, id: this.props.userData.id})}>
            Delete
          </Button>
        </div>
      </Modal>
    </React.Fragment>)
  }
}

DeleteModal.propTypes = {
  response: PropTypes.any, onUsersDelete: PropTypes.func,
};

const mapStateToProps = ({Users}) => ({
  response: Users.responseDelete,
  loading: Users.loadingDelete,
  error: Users.errorDelete,
});

const mapDispatchToProps = dispatch => ({
  onUsersDelete: data => dispatch(usersDelete(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DeleteModal));